import SectionHeading from "./SectionHeading";
import { siteMeta, updates } from "@/mocks/home";

const tagStyles: Record<string, string> = {
  换地址: "bg-primary-100 text-primary-700",
  维护: "bg-accent-100 text-accent-800",
  新入口: "bg-secondary-100 text-secondary-800",
  线路: "bg-background-200 text-foreground-700",
  安全: "bg-primary-500 text-background-50",
};

export default function UpdateFeed() {
  return (
    <section id="updates" className="bg-background-100 py-14 md:py-20 px-4 md:px-10">
      <SectionHeading
        eyebrow="最新更新维护"
        title="换地址、维护、线路调整，都在这里留痕"
        desc="每一次入口变更都会记录时间与原因，方便你随时核对当前地址是否还可用。看到「换地址」提示时，记得用最新公示地址重新进入。"
      />

      <div className="mt-10 grid lg:grid-cols-12 gap-6">
        <ol className="lg:col-span-8 relative pl-6 md:pl-8">
          <span className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-background-300" />
          {updates.map((item) => (
            <li key={`${item.date}-${item.title}`} className="relative pb-7 last:pb-0">
              <span className="absolute -left-6 md:-left-8 top-1.5 w-4 h-4 rounded-full bg-background-50 border-2 border-primary-400" />
              <div className="flex flex-wrap items-center gap-2 mb-2">
                <span className="font-heading text-sm font-bold text-foreground-900">
                  {item.date}
                </span>
                <span className="text-xs text-foreground-500">{item.time}</span>
                <span
                  className={`h-6 px-2.5 rounded-full text-xs font-medium inline-flex items-center ${
                    tagStyles[item.tag] ?? "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.tag}
                </span>
              </div>
              <h3 className="text-base font-medium text-foreground-950">{item.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </li>
          ))}
        </ol>

        <aside className="lg:col-span-4">
          <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-md bg-primary-50 flex items-center justify-center text-primary-600">
                <i className="ri-pulse-line text-xl" />
              </span>
              <div>
                <p className="text-xs text-foreground-500">当前状态</p>
                <p className="text-sm font-medium text-foreground-950">{siteMeta.statusText}</p>
              </div>
            </div>

            <div className="mt-5 space-y-3 text-sm">
              <div className="flex items-center justify-between">
                <span className="text-foreground-500">最近同步</span>
                <span className="text-foreground-900">{siteMeta.updatedAt}</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-foreground-500">本月换址</span>
                <span className="text-foreground-900">2 次</span>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-foreground-500">在维护线路</span>
                <span className="text-foreground-900">1 条</span>
              </div>
            </div>

            <div className="mt-5 pt-5 border-t border-background-200">
              <p className="flex items-start gap-2 text-xs leading-relaxed text-foreground-600">
                <i className="ri-information-line text-accent-600 mt-0.5" />
                <span>
                  本站不会通过私信、邮件单独通知新地址，请只以本页公示为准，避免误入仿冒站。
                </span>
              </p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}